import React from 'react';
import styles from './NmsOpenOrderFilter.module.scss';
import { FaAngleDoubleDown, FaAngleDoubleUp } from 'react-icons/fa';
import { Button } from '../../components/Button';
import { Label } from '../../components/Label';
import moment from 'moment';
import PropTypes from 'prop-types';
import { CheckBox, TextBox, TagBox } from 'devextreme-react';
import List from 'devextreme-react/list';
import { isEmpty } from '../../util/functions';
import { tifTypes } from '../../util/orderFilterConstants';
import { datePattern, timePattern } from '../../util/constants';

const disableAutoComplete = {
    autocomplete: 'off'
  };

const initialState = {
  symbol: '',
  mpid: ''
};

class NmsOpenOrderFilter extends React.Component {
  constructor (props) {
    const localStorageSearch = window.localStorage.getItem('recentNmsOpenOrderSearch');
    const recentSearches = localStorageSearch && JSON.parse(localStorageSearch);
    super(props);
    this.state = {
      ...initialState,
      errorMessages: [],
      collapseOnSearch: window.localStorage.getItem('tps_collapseSearch') === 'true',
      showFilter: true,
      recentSymbolSearch: recentSearches && recentSearches.symbol,
      recentMpidSearch: recentSearches && recentSearches.mpid
    };
    // preserve the initial state in a new object
    this.baseState = this.state;
    this.getOrderDataFilterAttributes = this.getOrderDataFilterAttributes.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRecentSearches = this.handleRecentSearches.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidUpdate (prevProps) {
    if (prevProps.isDataLoaded !== this.props.isDataLoaded) {
      if (this.props.isDataLoaded && this.state.collapseOnSearch) {
        this.setState({ showFilter: false });
      }
    }
  }

  toggleFilter = () => this.setState(state => ({ showFilter: !state.showFilter }));

  handleListItemClick = (e, name) => {
    this.setState({
      isSymbolFocus: false,
      isMpidFocus: false,
      [name]: e.itemData
    });
  }

  showToolTip = label => {
    this.setState({
      [label]: true
    });
  }

  hideToolTip = label => {
    this.setState({
      [label]: false
    });
  }

  handleChange (event, name) {
    //  console.log(event.value);
    //  console.log(name);
    this.setState({
      [name]: event.value
    });
  }

  handleSearch () {
    this.handleSubmit('search');
  }

  handleDownload () {
    this.handleSubmit('download');
  }

  handleSubmit (type) {
    let queryParam = this.state;
    //  console.log(queryParam);
    var errorMessages = [];
    if (isEmpty(queryParam['symbol']) && isEmpty(queryParam['mpid'])) {
        errorMessages.push('Please select Symbol or MPID ');
      }
  
    this.setState({ errorMessages: errorMessages });
    if (errorMessages.length === 0) {
      // put recent searches in the localstorage
      this.handleRecentSearches(queryParam);
      // try to get data
      let params = this.getOrderDataFilterAttributes(queryParam);
      this.props.search(params, type);
    }
  }

  handleRecentSearches (params) {
    const recentSearchStorage = window.localStorage.getItem('recentNmsOpenOrderSearch');

    let recentSearchData = {
      symbol: [],
      mpid: []
    };

    if (recentSearchStorage) {
      recentSearchData.symbol = JSON.parse(recentSearchStorage).symbol;
      recentSearchData.mpid = JSON.parse(recentSearchStorage).mpid;
    }

    const symbolField = params.symbol && params.symbol.toUpperCase();
    const mpidField = params.mpid && params.mpid.toUpperCase();
    if (symbolField && symbolField !== '') {
      if (!recentSearchData.symbol.includes(symbolField))recentSearchData.symbol.unshift(symbolField);

      if (recentSearchData.symbol.includes(symbolField)) {
        const symbolArray = recentSearchData.symbol;
        const index = symbolArray.indexOf(symbolField);
        symbolArray.splice(index, 1);
        symbolArray.unshift(symbolField);
      }
    }
    if (mpidField && mpidField !== '') {
      if (!recentSearchData.mpid.includes(mpidField))recentSearchData.mpid.unshift(mpidField);

      if (recentSearchData.mpid.includes(mpidField)) {
        const mpidArray = recentSearchData.mpid;
        const index = mpidArray.indexOf(mpidField);
        mpidArray.splice(index, 1);
        mpidArray.unshift(mpidField);
      }
    }
    if (recentSearchData.symbol.length > 10) recentSearchData.symbol.pop();

    if (recentSearchData.mpid.length > 10) recentSearchData.mpid.pop();

    window.localStorage.setItem('recentNmsOpenOrderSearch', JSON.stringify(recentSearchData));

    this.setState({
      isMpidFocus: false,
      isSymbolFocus: false,
      recentSymbolSearch: recentSearchData.symbol,
      recentMpidSearch: recentSearchData.mpid
    });
  }

  renderErrorMessages () {
    const errorMessages = this.state.errorMessages;
    return errorMessages.map((errorMessage, i) => <div key={`Error-${i}`}>{errorMessage}</div>);
  }

  getOrderDataFilterAttributes (queryParam) {
    var params = [];

    Object.keys(queryParam).forEach((key) => {
      let val = queryParam[key];
      if (val !== null) {
        if (key.toLowerCase().includes('date') && moment.isDate(val)) {
          params[key] = moment(val).format(datePattern);
        } else if (key.toLowerCase().includes('time') && moment.isDate(val)) {
          params[key] = moment(val).format(timePattern);
        } else if (typeof val === 'string') {
          if (val.trim() !== '') {
            params[key] = val;
          }
        } else {
          params[key] = val;
        }
      }
    });

    return params;
  }

  handleFocusIn (field) {
    this.setState({ [field]: true });
  }
  handleFocusOut (field) {
    setTimeout(() => { this.setState({ [field]: false }); }, 250);
  }

  handleCollapseOption = () => {
    this.setState(state => ({ collapseOnSearch: !state.collapseOnSearch }), () => window.localStorage.setItem('tps_collapseSearch', this.state.collapseOnSearch));
  }

  handleKeyDown (e) {
    if (e.key === 'Enter') {
      this.setState({
        isSymbolFocus: false,
        isMpidFocus: false
      });

      this.handleSubmit('search');
    };
  }

  render () {
    const { recentSymbolSearch, recentMpidSearch } = this.state;
    const isSymbolFocus = this.state.isSymbolFocus && recentSymbolSearch;
    const isMpidFocus = this.state.isMpidFocus && recentMpidSearch;
    const isFilterOpen = this.state.showFilter;
    return (
      <div id='NmsOpenOrderFilter' className={styles.container}>
        <div className={styles.formContainer}>

          {isFilterOpen && <div className={styles.orderGridStyle} onKeyDown={this.handleKeyDown}>

            <div key={'symbolKey'}>
              <Label title='Symbol' />
              <TextBox
                name={'symbol'} placeholder={'Symbol'} value={this.state['symbol']} showClearButton
                valueChangeEvent='keyup'
                onFocusIn={() => this.handleFocusIn('isSymbolFocus')}
                onFocusOut={() => this.handleFocusOut('isSymbolFocus')}
                onValueChanged={(e) => this.handleChange(e, 'symbol')} />
              {isSymbolFocus && recentSymbolSearch.length > 0 && <div className={styles.listContainer}>
                <i className={styles.note}>Recent searches:</i>
                <List
                  dataSource={recentSymbolSearch}
                  height='100%'
                  onItemClick={(e) => this.handleListItemClick(e, 'symbol')} />
              </div>}
            </div>
            <div key={'mpidKey'}>
              <Label title='MPID' />
              <TextBox
                name={'mpid'} placeholder={'MPID'} value={this.state['mpid']} showClearButton
                valueChangeEvent='keyup'
                onFocusIn={() => this.handleFocusIn('isMpidFocus')}
                onFocusOut={() => this.handleFocusOut('isMpidFocus')}
                onValueChanged={(e) => this.handleChange(e, 'mpid')} />
              {isMpidFocus && recentMpidSearch.length > 0 && <div className={styles.listContainer}>
                <i className={styles.note}>Recent searches:</i>
                <List
                  dataSource={recentMpidSearch}
                  height='100%'
                  onItemClick={(e) => this.handleListItemClick(e, 'mpid')} />
              </div>}

            </div>
            
            <div key={'tifKey'}>
              <Label title='TIF' />
              <TagBox id={'tifFilter'}
                dataSource={tifTypes}
                showClearButton
                placeholder={'TIF'}
                value={this.state['tifFilter']}
                displayExpr='value'
                valueExpr='id'
                name={'tifFilter'}
                showDropDownButton
                showSelectionControls
                wrapItemText
                maxDisplayedTags={2}
                showMultiTagOnly
                inputAttr={disableAutoComplete}
                onValueChanged={(e) => this.handleChange(e, 'tifFilter')} /></div>
          </div>

          }

          {!isFilterOpen && <div className={styles.collapsedContainer}>

            {this.state.symbol && <span className={styles.field}>
              <Label title='Symbol: ' isInline /> {this.state.symbol}
            </span>}
            {this.state.mpid && <span className={styles.field}>
              <Label title='MPID: ' isInline /> {this.state.mpid}
            </span>}
          </div>}

          <div className={styles.controls}>
            {isFilterOpen && <Button title='Search' onClick={this.handleSearch} size='extraSmall' /> }
            <Button title='Excel' size='extraSmall' inactive={this.props.isDownloadInactive} onClick={this.handleDownload} />
            {this.props.isDownloadInactive && <span> Downloading...</span>}
            {isFilterOpen && <div className={styles.collapseOption}>
              <CheckBox
                width='100%'
                text='Collapse filters upon search results'
                onValueChanged={this.handleCollapseOption}
                value={this.state.collapseOnSearch}
              />
            </div> }
          </div>
          <div className={styles.errorMessages}>
            {this.state.errorMessages.length > 0 && this.renderErrorMessages()}
          </div>

          <div className={styles.toggle} onClick={this.toggleFilter}>
            {this.state.showFilter && <FaAngleDoubleUp />}
            {!this.state.showFilter && <FaAngleDoubleDown />}
          </div>
        </div>
      </div>
    );
  }
}
export default NmsOpenOrderFilter;

NmsOpenOrderFilter.propTypes = {
  search: PropTypes.func,
  isDownloadInactive: PropTypes.bool,
  isDataLoaded: PropTypes.bool

};
